module.exports = __webpack_public_path__ + "img/dm.36801c77.svg";